import { create } from "zustand";

import type { Identity } from "@/domain/auth";
import { queryClient } from "@/core/query/client";

interface SessionState {
  identity: Identity | null;
  managementTenantSlug: string | null;
  ready: boolean;
  signedOutRemotely: boolean;
  setIdentity: (identity: Identity | null) => void;
  endRemoteSession: () => void;
  setManagementTenant: (slug: string) => void;
  setReady: (ready: boolean) => void;
}

export const useSession = create<SessionState>((set) => ({
  identity: null,
  managementTenantSlug: null,
  ready: false,
  signedOutRemotely: false,
  setIdentity: (identity) => set((state) => {
    if (state.identity?.userId !== identity?.userId) queryClient.clear();
    if (!identity) return { identity: null, managementTenantSlug: null, signedOutRemotely: false };
    const saved = identity.roles.includes("super_admin") ? globalThis.localStorage?.getItem("owo:management-tenant") : null;
    return { identity, managementTenantSlug: saved || identity.tenantSlug, signedOutRemotely: false };
  }),
  endRemoteSession: () => set((state) => {
    if (!state.identity) return state;
    queryClient.clear();
    return { identity: null, managementTenantSlug: null, signedOutRemotely: true };
  }),
  setManagementTenant: (slug) => set((state) => {
    if (!state.identity?.roles.includes("super_admin")) return state;
    globalThis.localStorage?.setItem("owo:management-tenant", slug);
    return { managementTenantSlug: slug };
  }),
  setReady: (ready) => set({ ready }),
}));
